import * as Yup from 'yup';
import { TestContextExtended } from './validationSchema';
import { validatePercentages } from 'views/ActivityDataEntry/ScopeUpstreamList/CategoryOneComponent/validationSchema';
import { MAX_TWO_DECIMALS_REGEX } from 'constants/constants';

// Custom validation function to check if both activityMappingRegionSpecId and address.country are required
// when one of them is filled
const fieldRequiredIfOneOriginFieldFilled: Yup.TestFunction = function (
  this,
  value
) {
  const { activityLabel, quantity, unit, bestFitRegion, origins, multiOrigin } =
    (this as Yup.TestContext & TestContextExtended).from?.[1]?.value;

  const isAnyFieldFilled = activityLabel || quantity || unit || bestFitRegion;

  if (isAnyFieldFilled && multiOrigin) {
    const isShare = this?.path.includes('share');
    if (isShare && origins?.length < 2) return true;
    return value !== undefined && value !== null && value !== '';
  }

  return true;
};

export const originsValidation = Yup.array().of(
  Yup.object().shape({
    activityMappingRegionSpecId: Yup.string()
      .nullable()
      .test(
        'requiredIfOneOriginFieldFilled',
        'Field is required',
        fieldRequiredIfOneOriginFieldFilled
      ),
    addressLabel: Yup.string()
      .nullable()
      .test(
        'requiredIfOneOriginFieldFilled',
        'Field is required',
        fieldRequiredIfOneOriginFieldFilled
      ),
    share: validatePercentages
      .min(0, 'Share must be greater than or equal to 0')
      .max(100, 'Share must be lesser than or equal to 100')
      .nullable()
      .test(
        'decimal-precision',
        'Value must have at most 2 decimal places',
        value => !value || MAX_TWO_DECIMALS_REGEX.test(value.toString())
      )
      .test(
        'requiredIfOneOriginFieldFilled',
        'Enter a valid share',
        fieldRequiredIfOneOriginFieldFilled
      )
      .test(
        'sumShouldBe100%',
        'Total origin share should be 100%',
        function () {
          const formValues = (this as Yup.TestContext & TestContextExtended)
            .from?.[1]?.value;
          const totalShare = formValues?.origins?.reduce(
            (sum, origin) => sum + (origin?.share ? Number(origin?.share) : 0),
            0
          );
          if(formValues?.multiOrigin){
            return totalShare === 100;
          }
          return true
        }
      ),
  })
);
